import React, { Component } from 'react'
import { HorizontalBar } from 'react-chartjs-2'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import NoData from './noData'

class TxStatusesHold extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selection: 'Today',
      chartData: {},
      noData: false,
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { props } = this
    if (prevProps.data !== this.props.data) {
      if (props.data && props.data.transaction_data) {
        const { data } = props
        if (data.transaction_data && data.aggregate) {
          const { sanctions, watch, face_match, liveness, demographic } = data.aggregate.hold
          const pep = watch
          const faceMatch = face_match + liveness
          const country = demographic
          const netkiReview = data.transaction_data.post_processing
          const customerReview = data.transaction_data.customer_review

          const labels = [
            'Sanction / Watchlist',
            'PEP / Adverse Media',
            'Face match / Liveness',
            'Country / Phone Mismatch',
            'Netki Review',
            'Customer Review',
          ]

          const chartData = {
            labels,
            datasets: [
              {
                label: 'Transactions Open',
                data: [sanctions, pep, faceMatch, country, netkiReview, customerReview],
                backgroundColor: ['#6ac9a3', '#6ca8c1', '#8d9096', 'teal'],
                hoverBackgroundColor: ['#6ac9a3', '#6ca8c1', '#8d9096', 'teal'],
              },
            ],
          }
          if ([sanctions, pep, faceMatch, country, netkiReview].filter((i) => i).length === 0) {
            this.setState({ noData: true })
          } else {
            this.setState({ noData: false })
            this.setState({ chartData })
          }
        }
      }
    }
  }

  render() {
    return (
      <div className='ibox float-e-margins animated fadeIn'>
        <div className='ibox-title'>
          <h5>
            Transaction Open For&nbsp;
            {this.props.timeSpan}
          </h5>
        </div>
        {this.state.noData && <NoData />}
        {!this.state.noData && (
          <div className='ibox-content' style={{ display: 'flex', height: 350 }}>
            <HorizontalBar
              data={this.state.chartData}
              options={{
                maintainAspectRatio: false,
              }}
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.allMetrics.isFetching,
  errorMessage: state.allMetrics.errorMessage,
  data: state.allMetrics.results,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TxStatusesHold))
